class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.boundClose = this.close.bind(this);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const target = event.target;
    if (!this.contains(target) || target.classList.contains('modal-overlay')) {
      this.close(false);
      return;
    }

    // Header search: clicks on the empty fullscreen area close the modal.
    // Skip the summary toggle (its opening click bubbles to body), the
    // content wrapper, and the Algolia results panel.
    if (this.classList.contains('header__search')) {
      const inSummary = target.closest('summary');
      const inContent = target.closest('.search-modal__content');
      const inPanel = target.closest('.aa-Panel');
      if (!inSummary && !inContent && !inPanel) {
        this.close(false);
      }
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    const closeButton = this.querySelector('button.search-close');
    if (closeButton) closeButton.addEventListener('click', this.boundClose);

    let elementToFocus = this.detailsContainer.querySelector('input:not([type="hidden"])');

    // Header search modal: on touch-first devices (phones, bare iPads),
    // focus the dialog container instead of the input so the on-screen
    // keyboard doesn't pop on open. Desktops, touchscreen laptops, and
    // iPads with a physical keyboard still get the input focused — the
    // media query evaluates live and flips when a keyboard is attached.
    if (this.classList.contains('header__search')) {
      const willPopSoftKeyboard = window.matchMedia('(any-pointer: coarse) and (hover: none)').matches;
      if (willPopSoftKeyboard) {
        const dialog = this.detailsContainer.querySelector('[role="dialog"]');
        if (dialog) elementToFocus = dialog;
      }
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      elementToFocus
    );
  }

  close(focusToggle = true) {
    const shouldFocusToggle = focusToggle === true;
    removeTrapFocus(shouldFocusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    const closeButton = this.querySelector('button.search-close');
    if (closeButton) closeButton.removeEventListener('click', this.boundClose);
  }
}

customElements.define('details-modal', DetailsModal);
